export const ROAST_TYPES = ['Espresso', 'Filter', 'Omni', 'Sample'] as const;
export type RoastType = (typeof ROAST_TYPES)[number];

export interface GreenBeanPickerItem {
  id: string;
  code: string;
  name: string;
}

export interface ImportRow {
  // resolved during parse from "<code> — <name>"
  sourceGreenBeanItemId: string;
  // shown in the read-only Source GB cell
  sourceGreenBeanLabel: string;
  initialQty: number;
  standardCost: number;
  roastType: RoastType | '';
}

export interface RowError {
  rowIndex: number;
  field: keyof ImportRow;
  message: string;
}
